import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { ISubscriptionProduct } from '../model/subscription-product.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionProductService {
  private http = inject(HttpClient);
  private publicProductByIdCache = new Map<string, Observable<ISubscriptionProduct>>();
  private publicProductCache = new Map<string, Observable<ISubscriptionProduct>>();

  getPublicById(id: string): Observable<ISubscriptionProduct> {
    const encodedId = encodeURIComponent((id ?? '').trim());
    const cacheKey = encodedId;
    const cached = this.publicProductByIdCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const request$ = this.http.get<ISubscriptionProduct>(
      `${environment.API_URL}/api/Subscription/public/${encodedId}`
    ).pipe(
      tap({
        error: () => this.publicProductByIdCache.delete(cacheKey)
      }),
      shareReplay(1)
    );

    this.publicProductByIdCache.set(cacheKey, request$);
    return request$;
  }

  getPublicByLoginAndSlug(login: string, slug: string): Observable<ISubscriptionProduct> {
    const encodedLogin = encodeURIComponent((login ?? '').trim());
    const encodedSlug = encodeURIComponent((slug ?? '').trim());
    const cacheKey = `${encodedLogin}::${encodedSlug}`;
    const cached = this.publicProductCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const request$ = this.http.get<ISubscriptionProduct>(
      `${environment.API_URL}/api/Subscription/public/${encodedLogin}/${encodedSlug}`
    ).pipe(
      tap({
        error: () => this.publicProductCache.delete(cacheKey)
      }),
      shareReplay(1)
    );

    this.publicProductCache.set(cacheKey, request$);
    return request$;
  }
}
